<template>
    <fragment>
        <b-form-file v-show="!progresso" v-model="file1" :state="Boolean(file1)" placeholder="Selecionar arquivo"
            accept="application/pdf" size="sm" drop-placeholder="Solte o arquivo aqui"
            @input="handleFileSelection"></b-form-file>
        <b-progress v-if="progresso" variant="info" :striped="true" max="100" height="1.2rem">
            <b-progress-bar :value="progresso">
                <span class="current-progress">{{ progresso }} %</span>
            </b-progress-bar>
        </b-progress>
    </fragment>
</template>

<script>
import pcaService from "@/services/entregas/pcaService";

export default {
    props: {
        itemID: {
            type: Number
        },
        newIdPrestacaoConta: {
            type: Number
        }
    },
    data() {
        return {
            file1: null,
            progresso: null
        }
    },
    methods: {
        async handleFileSelection() {
            try {
                this.progresso = 0
                //console.log('handleFileSelection', this.file1)
                if (!this.file1) {
                    this.$parent.errorMessage = "Não foi possível incluir";
                    return;
                }
                const data = new FormData();
                const onUploadProgress = (event) => {
                    this.progresso = Math.round((event.loaded * 100) / event.total);
                };
                data.append("formFile", this.file1);
                const response = await pcaService.sendFile(
                    this.itemID,
                    data,
                    onUploadProgress,
                    this.newIdPrestacaoConta
                );
                if (response && response.status == 200) {
                    this.$emit("updateAll", response.data);
                } else {
                    if (response) this.$toast.error(response.data.msg);
                    else this.$toast.error("Erro ao enviar o arquivo");
                }
            } catch (e) {
                console.error('Erro ao enviarArquivo, componente EnviarArquivoCell', e)
            } finally {
                this.progresso = null
            }
        },
    }
}
</script>

<style scoped></style>